import React from 'react'
import {faTrashAlt} from "@fortawesome/free-solid-svg-icons/faTrashAlt";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {apiStatus} from '../../shared/enums'

export default {
    isFileTooBig: false,
    isTooManyFiles: false,
    uploadStatus: apiStatus.DEFAULT,
    fileContainsSpecialCharacter: false,
    uploadErrorCode: null,
    isModalOpen: false,
    modalTitle: '',
    files: [],
    fileListDeleteIcon: null,
    maxNumFiles: 10,
    maxFileSize: 26214400,
    dzoneProps: {},
    change: {
        operation: '', // string: add or remove
        delta: ''     //  number: how many files added/removed
    }
}

export const listDefaults = {
    removeFileUploadAction:{
        id: 'MEDCAL_RX_REMOVE_PA_ATTACHMENT',
        className: 'btn-danger',
        icon: <FontAwesomeIcon icon={faTrashAlt}/>,
        tooltip: 'Remove File',
        type: 'icon-only'
    },
    title: 'Files to Upload'
}